import React, { Fragment, useEffect, useState } from 'react'
import { Col, Row, Table, CardBody } from 'reactstrap'
import { Link } from 'react-router-dom'
import { API_URL } from './utils/Constants/URLS'
import PageHeader from './utils/PageHeader'
import PageLoader from './utils/PageLoader'
import '../css/OrgContacts.css'
import '../css/common.css'

const ViewFocSoInvoice = () => {
    const token = localStorage.getItem('token')
    const [soData, setSoData] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchSo, setSearchSo] = useState('')

    useEffect(() => {
        const fetchSO = async () => {
            setLoading(true)
            try {
                // Fetch all FOC sales orders
                const res = await fetch(`${API_URL}foc/sales-order`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                })
                const result = await res.json()
                const docs = result?.data?.docs ?? []
                // Filter for approved SOs only, as only approved SOs can start invoice journey
                const approvedDocs = docs.filter(doc => (doc.salesOrder ? doc.salesOrder.status === 'approved' : doc.status === 'approved'))
                setSoData(approvedDocs)
            } catch (e) {
                console.error('fetchSO error', e)
            } finally {
                setLoading(false)
            }
        }

        fetchSO()
    }, [token])

    const formatDate = iso => {
        if (!iso) return '-'
        try {
            return new Date(iso).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            })
        } catch {
            return iso
        }
    }

    const getDisplayLineItems = (so) => {
        const soLineItems = Array.isArray(so?.lineItems) ? so.lineItems : []
        return soLineItems
    }

    const renderModels = (lineItems) => {
        if (!Array.isArray(lineItems) || lineItems.length === 0) return '-'

        return lineItems.map((li, i) => {
            const modelObj = li?.model
            const name = modelObj?.modelName ?? li?.modelName ?? modelObj?._id ?? li?.partCode ?? '-'
            const qty = li?.quantity ?? li?.qty ?? '-'

            return (
                <div key={li?._id ?? `${name}-${i}`}>
                    {name} <small className='text-muted'>({qty})</small>
                </div>
            )
        })
    }

    // Filter based on search
    const filteredData = soData.filter(item => {
        const so = item.salesOrder || item
        const soNumber = so.salesOrderNumber || ''
        const clientName = so.lead?.client?.companyName || so.client || ''
        const term = searchSo.toLowerCase()
        return soNumber.toLowerCase().includes(term) || clientName.toLowerCase().includes(term)
    })

    return (
        <Fragment>
            <PageHeader
                pageName='FOC INVOICE JOURNEY'
                breadcrump1='Home'
                breadcrump2='Start FOC Invoice'
                link='/dashboard'
            />

            <div className='main lg:p-6 xl:p-6 2xl:p-6 sm:p-3 md:p-3 '>
                {/* Search + Action row */}
                <CardBody className='bg-white p-3 mb-3'>
                    <form>
                        <Row>
                            <Col lg={3} md={4} sm={6} xs={12}>
                                <input
                                    className='form-control'
                                    type='text'
                                    placeholder='Search FOC Sales Orders'
                                    value={searchSo}
                                    onChange={e => setSearchSo(e.target.value)}
                                />
                            </Col>
                        </Row>
                    </form>
                </CardBody>

                {/* Table */}
                <CardBody>
                    <div className='table-responsive w-full mb-3'>
                        {loading && <PageLoader />}

                        {!loading && (
                            <Table hover className='align-middle table-nowrap'>
                                <thead className='table-light'>
                                    <tr>
                                        <th>#</th>
                                        <th>Sales Order No</th>
                                        <th>Client</th>
                                        <th>Models</th>
                                        <th>Date of SO</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredData.length === 0 ? (
                                        <tr>
                                            <td colSpan='6' className='text-center py-4'>
                                                No approved FOC sales orders found
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredData.map((item, idx) => {
                                            const so = item.salesOrder || item
                                            const displayLineItems = getDisplayLineItems(so)
                                            return (
                                                <tr key={so._id ?? idx}>
                                                    <td>{idx + 1}</td>
                                                    <td>
                                                        <Link
                                                            to={`${so?._id}/${so?.salesOrderNumber}`}
                                                            className='text-dark no-underline'
                                                        >
                                                            {so.salesOrderNumber ?? '-'}
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        {so?.lead?.client?.companyName ?? so?.client?.companyName ?? '-'}
                                                    </td>
                                                    <td>{renderModels(displayLineItems)}</td>
                                                    <td>{formatDate(so.dateOfSO ?? so.createdAt)}</td>
                                                </tr>
                                            )
                                        })
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </div>
                </CardBody>
            </div>
        </Fragment>
    )
}

export default ViewFocSoInvoice
